import { useExperimentsContext } from '../../experiments/components/ExperimentsContext'
import { EXPERIMENT_NAME_CART_INTERMEDIATE_DRAWER } from '../../experiments/model/EXPERIMENT_NAME'
import { userApiSwrRefetchMiniCart } from '../../user-data'
import { handleAddToCartErrorApm } from '../api/addToCartErrorApmLogger'
import {
  type CartIntermediateAddToCartProps,
  useCartIntermediateApiSwrProductAddToCartMutation,
} from '../api/swr/useCartIntermediateApiSwrProductAddToCartMutation'
import { updateIsDataSuccessfullyAddedToCartFromResponse } from '../helpers/updateIsDataSuccessfullyAddedToCartFromResponse'
import { cartIntermediateAccessorGetDrawerMessages } from '../model/cartIntermediateMutationResponseDataAccessor'

import { useCartIntermediateContext } from './useCartIntermediateContext'

export const useProductAddToCart = ({
  currentPrescriptionType,
  offerId,
  product,
  quantity,
  redpoints,
}: CartIntermediateAddToCartProps): {
  handleAddToCart: () => Promise<void>
  isMutating: boolean
} => {
  const productAddToCartMutation =
    useCartIntermediateApiSwrProductAddToCartMutation({
      currentPrescriptionType,
      offerId,
      quantity,
      redpoints,
    })
  const {
    openCartIntermediateDrawerWithData,
    resetCartIntermediateContext,
    setIsDataSuccessfullyAddedToCart,
    specialOffersCollapsibleControls: { handleClose: closeSpecialOffers },
  } = useCartIntermediateContext()
  const { addExperimentKeysForActivation } = useExperimentsContext()

  const handleAddToCart = async (): Promise<void> => {
    resetCartIntermediateContext()
    if (!product || !offerId) {
      return
    }

    const products = [
      {
        id: offerId,
        prescriptionType: currentPrescriptionType,
        product,
        redpoints,
      },
    ]

    try {
      await productAddToCartMutation.trigger()
      await userApiSwrRefetchMiniCart()
    } catch (error) {
      handleAddToCartErrorApm(error)
    } finally {
      const response = productAddToCartMutation.data ?? null
      const drawerMessages = cartIntermediateAccessorGetDrawerMessages(response)
      updateIsDataSuccessfullyAddedToCartFromResponse(
        response,
        setIsDataSuccessfullyAddedToCart,
      )
      closeSpecialOffers()
      addExperimentKeysForActivation(EXPERIMENT_NAME_CART_INTERMEDIATE_DRAWER)
      openCartIntermediateDrawerWithData(products, drawerMessages, quantity)
    }
  }

  return {
    handleAddToCart,
    isMutating: productAddToCartMutation.isMutating,
  }
}
